import { useMutation } from '@tanstack/react-query';

import { config } from '~/config';
import { useRequest } from '~/lib/useRequest';
import { PatchStudentResponse, PatchStudentRequestBody } from '@ab/ams-school-api/types/private/v1';
import { hasKey } from '~/utils';

type PatchStudentParams = {
  id: string;
  payload: Omit<PatchStudentRequestBody['data'], 'type'>;
};

export function usePatchStudent() {
  const request = useRequest();
  const { isLoading, mutateAsync } = useMutation(['student'], async ({ id, payload }: PatchStudentParams) => {
    return await request<PatchStudentResponse>(`${config.apiHost}/private/v1/students/${id}`, {
      method: 'PATCH',
      body: {
        data: payload,
      } as PatchStudentRequestBody,
      isExpectedResponse,
    });
  });

  return {
    patchStudent: mutateAsync,
    isPatchingStudent: isLoading,
  };
}

function isExpectedResponse(res: unknown): res is PatchStudentResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
